import React from "react";
import {Container,ConFacturas} from "./styles";
import { REACT_APP_MULTIMEDIA_EPAYCO_ORIGIN } from "../../../config/env";


export function MainCont({children,plantilla}) {

    const Plantillas = {
        3: REACT_APP_MULTIMEDIA_EPAYCO_ORIGIN + "/dashboard/recaudo/proyecto/imagenes/plantilla_1.png",
        2: REACT_APP_MULTIMEDIA_EPAYCO_ORIGIN + "/dashboard/recaudo/proyecto/imagenes/plantilla_2.png",
        1: REACT_APP_MULTIMEDIA_EPAYCO_ORIGIN + "/dashboard/recaudo/proyecto/imagenes/plantilla_3.png",
        4: REACT_APP_MULTIMEDIA_EPAYCO_ORIGIN + "/dashboard/recaudo/proyecto/imagenes/plantilla_4.png",
    };

    return (
        <Container plantilla={Plantillas[plantilla]}>
            {children}
        </Container>
    )
}

export default React.memo(MainCont);

export const FacturaContainer = ({children})=>{
    return (
        <ConFacturas>
            {children}
        </ConFacturas>
    )
};

